// Generated types for User
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { BusinessRole } from '../../shared/enums';

import { PrivateNodeReadAPI, PrivateNodeWriteAPI } from '../../shared/types/privatenode';
import { PrivateNodeReadAPISchemaObject, PrivateNodeWriteAPISchemaObject } from '../../shared/types/privatenode';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface UserReadAPI extends Omit<PrivateNodeReadAPI, 'version'> {
  /** Name of the user */
  name?: string;
  /** Image url of the user avatar */
  avatar?: string;
}

export interface UserWriteAPI extends PrivateNodeWriteAPI {
  /** Name of the user */
  name?: string;
  /** Make name and avatar discoverable to registered users */
  public_profile?: boolean;
  /** Image url of the user avatar */
  avatar?: string;
  /** Language that should be used to communicate with the user */
  locale?: string;
  /** Main user activity within the organisation */
  role?: BusinessRole;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const UserReadAPISchema: z.ZodType<UserReadAPI> = PrivateNodeReadAPISchemaObject.omit({ 'version': true }).extend({
  name: z.string().optional(),
  avatar: z.string().optional(),
}).passthrough();

export const UserWriteAPISchema: z.ZodType<UserWriteAPI> = PrivateNodeWriteAPISchemaObject.extend({
  name: z.string().optional(),
  public_profile: z.boolean().optional(),
  avatar: z.string().optional(),
  locale: z.string().optional(),
  role: z.nativeEnum(BusinessRole).optional(),
}).passthrough();
